<template>
    <div>
        <div class="grid grid-cols-2 gap-4">
            <CatalogueTile
                v-if="items[0]"
                :image="items[0].image.sizes.small"
                :hover-image="items[0].hover_image.sizes.small"
                :medium-image="items[0].medium_image.sizes.small"
                :small-image="items[0].small_image.sizes.small"
                :title="items[0].title"
                :is-new="items[0].is_new"
                :link="items[0].url"
                :external-link="items[0].url.charAt(0) !== '/'"
                :content="items[0].content"
                half-image
            />
            <CatalogueTile
                v-if="items[1]"
                :image="items[1].image.sizes.small"
                :hover-image="items[1].hover_image.sizes.small"
                :medium-image="items[1].medium_image.sizes.small"
                :small-image="items[1].small_image.sizes.small"
                :title="items[1].title"
                :is-new="items[1].is_new"
                :link="items[1].url"
                :external-link="items[1].url.charAt(0) !== '/'"
                :content="items[1].content"
                half-image
            />
            <CatalogueTile
                v-if="items[2]"
                :image="items[2].image.sizes.small"
                :hover-image="items[2].hover_image.sizes.small"
                :medium-image="items[2].medium_image.sizes.small"
                :small-image="items[2].small_image.sizes.small"
                :title="items[2].title"
                :is-new="items[2].is_new"
                :link="items[2].url"
                :external-link="items[2].url.charAt(0) !== '/'"
                :content="items[2].content"
                half-image
            />
            <CatalogueTile
                v-if="items[3]"
                :image="items[3].image.sizes.small"
                :hover-image="items[3].hover_image.sizes.small"
                :medium-image="items[3].medium_image.sizes.small"
                :small-image="items[3].small_image.sizes.small"
                :title="items[3].title"
                :is-new="items[3].is_new"
                :link="items[3].url"
                :external-link="items[3].url.charAt(0) !== '/'"
                :content="items[3].content"
                half-image
            />
        </div>
    </div>
</template>

<script>
import CatalogueTile from '@/components/CatalogueTile';

export default {

    components: {
        CatalogueTile,
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
    },

};
</script>

<style lang="scss" scoped>
.transform-scale {
    transform: scale(0.95);
}
</style>
